// @ts-check
import Icon from 'components/base/Icon';
import {
  StyledFooter,
  StyledHeader,
  StyledInsightsConfig,
  StyledMain,
  StyledSubHeader
} from './InsightsConfig.style';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import useInsightsSetting from '../../useInsights/useInsightsSetting';
import useFormState from './useFormState/useFormState';
import useFormSaveHandler from './useFormState/useFormSaveHandler';
import InsightsFormStateContext from './useFormState/form.state.context';
import { INSIGHTS_CATEGORIES, INSIGHTS_KEYS } from '../../insights.keys';
import NoGitActivity from './insights/NoGitActivity';
import ContextSwitch from './insights/ContextSwitch';
import SwitchOnlyInsight from './insights/SwitchOnlyInsight';
import StuckIssuesInState from './insights/StuckIssuesInState';
import RevertToDefault from './RevertToDefault';
import useAmplitudeVisit from 'common/hooks/tracking/useAmplitudeVisit';
import { TRACKING } from 'common/constants/constants';
import usePmViewer from 'common/hooks/pm/usePmViewer';
import { capitalize } from 'lodash';
import { LBButton } from '@linearb/buzz';

const InsightsConfig = () => {
  useAmplitudeVisit({
    page: TRACKING.PAGES.PROJECT_PROGRESSION_INSIGHTS_CONFIG
  });
  const history = useHistory();
  const insightsSetting = useInsightsSetting();
  const {
    formState,
    hasFormChanged,
    getInsight,
    updateInsight,
    onToggleSwitch
  } = useFormState(insightsSetting.value);
  const formSaveHandler = useFormSaveHandler({ insightsSetting, formState });
  const pmViewer = usePmViewer();
  const issuesText = capitalize(pmViewer.ticket.plural);

  const onClose = () =>
    history.replace(AppRouter.PROJECTS_PROJECT_PROGRESSION.path);

  return (
    <StyledInsightsConfig>
      <InsightsFormStateContext.Provider
        value={{
          getInsight,
          updateInsight,
          onToggleSwitch
        }}
      >
        <div className='flex justify-between'>
          <StyledHeader>
            <Icon name='Bulb' style={{ marginRight: '0.5rem' }} />
            Insights Settings
          </StyledHeader>

          <div>
            <LBButton variant='ghost' onClick={onClose} size='icon'>
              <Icon name='Close' size='x-medium' />
            </LBButton>
          </div>
        </div>
        <StyledMain>
          <StyledSubHeader>
            {INSIGHTS_CATEGORIES.delivery_risk.name}
          </StyledSubHeader>
          <NoGitActivity />
          {/* <CarriedOverSprints /> */}
          <StuckIssuesInState />

          <StyledSubHeader>
            {INSIGHTS_CATEGORIES.resource_management.name}
          </StyledSubHeader>
          <ContextSwitch />

          <StyledSubHeader>
            {INSIGHTS_CATEGORIES.jira_hygiene.name}
          </StyledSubHeader>
          <SwitchOnlyInsight
            insight={getInsight(INSIGHTS_KEYS.ISSUES_WITH_NO_ESTIMATION)}
            text={`${issuesText} missing a time estimate`}
          />
          <SwitchOnlyInsight
            insight={getInsight(INSIGHTS_KEYS.ISSUES_NO_ASSIGNEES)}
            text={`${issuesText} missing an assignee`}
          />
          <SwitchOnlyInsight
            insight={getInsight(INSIGHTS_KEYS.ISSUES_NO_BRANCHES)}
            text={`${issuesText} are missing git branch data`}
          />
        </StyledMain>
        <StyledFooter>
          <RevertToDefault onClick={formSaveHandler.onRevert} />
          <LBButton
            onClick={async () => {
              await formSaveHandler.onSave();
              onClose();
            }}
            disabled={formSaveHandler.isLoading || !hasFormChanged}
          >
            Save & Close
          </LBButton>
        </StyledFooter>
      </InsightsFormStateContext.Provider>
    </StyledInsightsConfig>
  );
};

export default InsightsConfig;
